import { bgRequestSelector, bgRequestSlice } from 'Pages/ibro'
import { useAppDispatch } from 'Src/hooks'
import { useEffect } from 'react'
import { useSelector } from 'react-redux'

const actions = {
	getDict: bgRequestSlice.actions.getDict,
}
export const useBgDict = () => {
	const { getDict } = useAppDispatch(actions)

	const dict = useSelector(bgRequestSelector.selectDict)
	const typeLegalAuthoritiesDict = useSelector(bgRequestSelector.getTypeLegalAuthoritiesDict)
	const typeLegalAuthorityItems = useSelector(bgRequestSelector.getTypeLegalAuthorities)
	const taxationOptionsOOO = useSelector(bgRequestSelector.getTaxationSystems)
	const taxationSystemsDict = useSelector(bgRequestSelector.getTaxationSystemsDict)
	const statuses = useSelector(bgRequestSelector.selectStatuses)
	const segments = useSelector(bgRequestSelector.selectSegments)
	const ptypes = useSelector(bgRequestSelector.selectPtypes)
	const guaranteemediumTypes = useSelector(bgRequestSelector.selectGuaranteemediumTypes)
	const arbitragesOptions = useSelector(bgRequestSelector.selectArbitragesOptions)
	const optionsReputationType = useSelector(bgRequestSelector.getReputations)
	const factItems = useSelector(bgRequestSelector.getFacts)
	const purchaseTypes = useSelector(bgRequestSelector.getPurchasetypes)
	const guaranteetypes = useSelector(bgRequestSelector.getGuaranteetypes)
	const allowedSymbols = useSelector(bgRequestSelector.selectAllowedSymbols)
	const publicationSubjects = useSelector(bgRequestSelector.selectPublicationSubjects)

	useEffect(() => {
		if (!dict) getDict()
	}, [getDict, dict])

	return {
		typeLegalAuthoritiesDict,
		typeLegalAuthorityItems,
		taxationOptionsOOO,
		taxationSystemsDict,
		guaranteemediumTypes,
		statuses,
		segments,
		ptypes,
		arbitragesOptions,
		optionsReputationType,
		factItems,
		purchaseTypes,
		guaranteetypes,
		allowedSymbols,
		publicationSubjects,
	}
}
